import { Box, useTheme } from "@mui/material";
import { useEffect, useRef } from "react";
import BenefitsSection from "./components/BenefitsSection";
import HeroSection from "./components/HeroSection";
import OurFeaturesSection from "./components/OurFeaturesSection";
import SubscribeSection from "./components/SubscribeSection";

const Home = () => {
  const theme = useTheme();
  const section1Ref = useRef<HTMLElement>(null);
  const section2Ref = useRef<HTMLElement>(null);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const offsetRef = useRef(0);
  const speed = 0.05;

  useEffect(() => {
    const handleSmoothScroll = () => {
      if (scrollContainerRef.current) {
        const height =
          scrollContainerRef.current.getBoundingClientRect().height - 1;
        document.body.style.height = `${Math.floor(height)}px`;

        const scrollLoop = () => {
          offsetRef.current += (window.pageYOffset - offsetRef.current) * speed;
          if (scrollContainerRef.current) {
            scrollContainerRef.current.style.transform = `translateY(-${offsetRef.current}px) translateZ(0)`;
          }
          requestAnimationFrame(scrollLoop);
        };

        scrollLoop();
      }
    };

    handleSmoothScroll();
  }, []);

  return (
    <Box
      // ref={scrollContainerRef}
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: "100vh",
        transition: "background-color 0.3s ease",
      }}
    >
      <HeroSection
        section1Ref={section1Ref}
        section2Ref={section2Ref}
      />
      {/* Change layoutType prop to switch between layouts: "grid" | "carousel" */}
      <OurFeaturesSection section2Ref={section2Ref} layoutType="carousel" />
      <BenefitsSection />
      <SubscribeSection />
    </Box>
  );
};

export default Home;
